<template>
  <div>
    <v-data-table
      hide-default-footer
      class="elevation-1"
      sort-by="id"
      sort-desc
      :headers="headers"
      :items="models"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :item-class="rowClass"
      @page-count="pageCount = $event"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-btn tile color="primary" class="link non-text-transformation" @click="upload" data-cy="open-dialog">
            {{ $t('ADMIN_RATE_MODELS_UPLOAD_BUTTON') }}
          </v-btn>

          <v-spacer class="mx-4" />

          <div class="d-flex align-center text-body-2">
            <div class="mr-2">{{ $t('ADMIN_TABLE_RESULTS_PER_PAGE') }}</div>

            <v-select
              dense
              v-model="itemsPerPage"
              :items="perPageValues"
              class="admin__results-per-page"
            />
          </div>
        </v-toolbar>
      </template>

      <template v-slot:item.isDefault="{ item }">
        <v-icon small :color="item.isDefault ? 'success' : 'grey lighten-1'">
          {{ item.isDefault ? 'mdi-check-circle' : 'mdi-circle-outline' }}
        </v-icon>
      </template>

      <template v-slot:item.isActive="{ item }">
        <v-icon small :color="item.isActive ? 'success' : 'grey lighten-1'">
          {{ item.isActive ? 'mdi-check-circle' : 'mdi-circle-outline' }}
        </v-icon>
      </template>

      <template v-slot:item.legalCities="{ item }">
        {{ item.legalCities && item.legalCities.length ? item.legalCities.join(', ') : '—' }}
      </template>

      <template v-slot:no-data>
        <div class="mt-4 mb-2 text-body-2 admin__no-data">
          {{ $t('ADMIN_TABLE_NO_RESULTS') }}
        </div>

        <v-btn color="primary" class="mb-4" @click="requestModels">
          {{ $t('ADMIN_UPDATE') }}
        </v-btn>
      </template>

      <template v-slot:footer>
        <v-pagination class="py-4" v-model="page" :length="pageCount" />
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="510">
      <v-card>
        <v-card-title class="text-h3">{{ $t('ADMIN_RATE_MODELS_MODAL_TITLE') }}</v-card-title>

        <div class="ml-8 admin__file-input">
          <v-file-input
            v-model="files"
            outlined
            label="Selecciona un archivo para subir."
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            truncate-length="19"
          />
        </div>

        <v-card-actions class="d-flex justify-end pa-4">
          <v-btn tile outlined color="black" class="link non-text-transformation" @click="close">
            {{ $t('ADMIN_CANCEL') }}
          </v-btn>

          <v-btn tile color="primary" class="link non-text-transformation" @click="submit" data-cy="send-file">
            {{ $t('ADMIN_CONTINUE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { REQUEST_MODELS, UPLOAD_MODEL } from '@/store/modules/offer/actions'

export default {
  name: 'RateModels',
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      perPageValues: [5, 10, 25, 50, 100],
      headers: [
        {
          text: this.$t('ADMIN_RATE_MODELS_TABLE_HEADER_ID'),
          value: 'id',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_RATE_MODELS_TABLE_HEADER_DESCRIPTION'),
          value: 'description',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_RATE_MODELS_TABLE_HEADER_ORGANIZATION'),
          value: 'organization',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_RATE_MODELS_TABLE_HEADER_CURRENCY'),
          value: 'currencyISO',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_RATE_MODELS_TABLE_HEADER_IS_DEFAULT'),
          value: 'isDefault',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_RATE_MODELS_TABLE_HEADER_IS_ACTIVE'),
          value: 'isActive',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_RATE_MODELS_TABLE_HEADER_START_DATE'),
          value: 'startDate',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_RATE_MODELS_TABLE_HEADER_END_DATE'),
          value: 'endDate',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_RATE_MODELS_TABLE_HEADER_PAYMENT_DAY_LIMIT'),
          value: 'paymentDayLimit',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_RATE_MODELS_TABLE_HEADER_PAYMENT_METHODS'),
          value: 'paymentMethodsCount',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_RATE_MODELS_TABLE_HEADER_EXTRA_SERVICES'),
          value: 'extraServicesCount',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_RATE_MODELS_TABLE_HEADER_LEGAL_CITIES'),
          value: 'legalCities',
          class: 'text-body-2',
        },
      ],
      models: [],
      dialog: false,
      files: [],
    }
  },
  methods: {
    ...mapActions('offer', [REQUEST_MODELS, UPLOAD_MODEL]),
    ...mapActions('alerts', ['createAlert']),
    async requestModels() {
      const response = await this[REQUEST_MODELS]()

      if ('error' in response) {
        this.createAlert({
          id: 'adminModels',
          type: 'error',
          contentKey: 'ADMIN_ALERT_TEXT',
          dismissible: false,
          details: response.error,
        })
      } else {
        this.models = response.data
      }
    },
    upload() {
      this.dialog = true
    },
    close() {
      this.files = []
      this.dialog = false
    },
    submit() {
      let formData = new FormData()
      formData.append('file', this.files, `modeloTarifario.xlsx`)
      this[UPLOAD_MODEL]({ rateModel: formData })
      this.dialog = false
    },
    rowClass() {
      return 'text-body-2'
    },
  },
  created() {
    this.requestModels()
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.close()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.admin {
  &__file-input {
    width: rem(400);
  }
  &__no-data {
    color: #444444;
  }
  &__results-per-page {
    width: rem(60);
  }
}
</style>
